import { StandaloneLoopAround } from 'base/components/LoopAround';

const HantStandaloneLoopAround: typeof StandaloneLoopAround = (props) => {
  return <StandaloneLoopAround {...props} velocity={-0.7} />;
};

export default HantStandaloneLoopAround;
